// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"69":"bfe311591f91b055e0e1","655":"ab2c5c4973a4e69c104d"}[chunkId] + ".js";
};